import astranaLogoPlum  from 'assets/images/Astrana_Symbol_Plum.svg';
import './style.scss';

const LandingPage = () => {
  return (
    <div className="page landing-page">
      <img src={astranaLogoPlum} alt="Astrana" />
      <br />
      <span>
      Provider Portal
      </span>
    </div>
  );
};

export default LandingPage;
